module.exports = __webpack_public_path__ + "static/img/join_active.272563e8.svg";